((($) => {
    'use strict';
    
    // Add a class to links in the header that are same-page links. We're using that class to
    // give them a different icon.
    if (Drupal) {
        // Drupal will call attach() for all behaviors after the page is loaded.
        Drupal.behaviors.addClassToSamePageHeaderLinks = {
            attach: function (context, settings) {
                $('.page-header .page-header-metadata-published-tags a').each(function(){
                    const $link = $(this);
            
                    if($link.attr('href').startsWith('#')) {
                        $link.addClass('page-header-metadata-same-page');
                    }
                });
            }
        };
    }
})(jQuery));
